import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { sortObjectByOrder, asList, joinClasses, parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import { track } from 'utils/tracking';
import { Link } from 'components/core/link/link';
import Transition from 'components/core/transition/transition.js';
import Youtube from 'components/shared/youtube/youtube.js';
import Playlist from 'components/shared/playlist/playlist.js';
import SimpleVideoPlayer from 'components/shared/simpleVideoPlayer/simpleVideoPlayer.js';
import s from 'components/shared/carousel/carousel.sss';
import HTML from 'components/core/html/html';
import Iframe from 'components/core/iframe/iframe';
import { getCopy } from 'utils/copy';
import Geo from 'models/Geo';
import { STDate } from 'models/Screening';

export default class Carousel extends Component {

	constructor(props) {
		super(props);

		this.renderItem = this.renderItem.bind(this);
		this.renderAnnotation = this.renderAnnotation.bind(this);


		this.sortedItems = Array.isArray(props.slides) ? props.slides : sortObjectByOrder(props.slides);
		this.sortedItems = this.sortedItems.filter(el => el.visible !== false);
		this.itemCount   = this.sortedItems.length;
		this.duration    = props.slideDuration ? +props.slideDuration : 500;
		this.delay       = +props.slideDelay || 0;
		this.$items      = [];

		const transition = props.transition || 'fade';

		this.enteringClass = s[transition + 'In'];
		this.visibleClass  = s[transition + 'Visible'];
		this.leavingClass  = s[transition + 'Out'];
		this.emptyClass    = s[transition + 'Empty'];

		this.$videos = [];

		this.state = {
			showReadMore:      false,
			zoom:              false,
			currentItemIndex:  0,
			previousItemIndex: 0,
			muted:             Store.get().misc.muted || false
		};

		Store.on(actions.TOGGLE_MUTE, (muted) => this.setState({ muted }));

		this.imageItemClick = this.imageItemClick.bind(this);
	}


	// =~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=
	// React lifecycle

	componentDidMount() {
		this.newPropsHandler(this.props);
		if (this.props.autoSlide) {
			this.addTimeout();
		}
	}

	componentWillReceiveProps(nextProps) {
		this.newPropsHandler(nextProps);
	}

	newPropsHandler(props) {
		const activeItem = this.sortedItems[this.state.currentItemIndex];
		const activeVideo = this.$videos[this.state.currentItemIndex];
		if (!activeVideo || !('activeSection' in props) || activeItem.playWhenInactive || activeItem.disableAutoplayOnActiveSection) return;
		// Pause/Play the video depending if the section is active
		activeVideo[props.activeSection ? 'play' : 'pause']();
	}

	// =~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=
	// Custom methods

	addTimeout(currentItem) {
		if (currentItem === undefined) {
			currentItem = this.state.currentItemIndex;
		}
		const item = this.sortedItems[currentItem] || {};
		if (item.type === 'youtube') {
			return;
		}
		const duration = +item.slideDuration || this.duration;
		const delay = +item.slideDelay || this.delay;
		this.timer = setTimeout(this.nextSlide, duration + delay);
	}


	// =~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=~=
	// Event handlers

	setSlide = (index) => {
		if (index !== this.state.currentItemIndex) {
			if (this.props.trackId) {
				track({ a: `set-slide-${this.props.trackId}-${index}` });
			}

			this.setState({
				previousItemIndex: this.state.currentItemIndex,
				currentItemIndex: index
			});
		}

		clearTimeout(this.timer);
		if (this.props.autoSlide) {
			this.addTimeout(index);
		}
	}

	setSlideByItem = (item) => {
		this.setSlide(this.sortedItems.indexOf(item));
	}

	prevSlide = (event) => {
		if (event) event.preventDefault();

		if(this.$videos[this.state.currentItemIndex]){
			this.$videos[this.state.currentItemIndex].pause();
		}

		let newIndex = this.state.currentItemIndex - 1;
		if (newIndex < 0) newIndex += this.itemCount;
		this.setSlide(newIndex);
	}

	nextSlide = (event) => {
		if (event && event.preventDefault) {
			event.preventDefault();
		}

		if(this.$videos[this.state.currentItemIndex]){
			this.$videos[this.state.currentItemIndex].pause();
		}
		let newIndex = this.state.currentItemIndex + 1;
		if (newIndex >= this.itemCount) newIndex = 0;
		this.setSlide(newIndex);
	}

	toggleFullBody = (event) => {
		event.preventDefault();
		this.setState({ showReadMore: !this.state.showReadMore });
	}

	imageItemClick() {
		return null;
	}

	toggleZoom = (event) => {
		if(event && !this.props.disableZoom) event.preventDefault();
		this.setState({ zoom: !this.state.zoom });
	}

	triggerFilters = (link) => {
		const filters = this.props.showtimes.filters;
		const lFilters = link.filters;
		if (!lFilters) return;

		let shouldUpdate = false;

		Object.keys(lFilters).forEach(filterKey => {
			const val = lFilters[filterKey];
			if (!val) return;

			if (filterKey === 'location') {
				let currentLoc = Store.get().client.geo;
				let newLoc = new Geo(val);
				if (!newLoc.equals(currentLoc)) {
					Store.emit(actions.SET_CLIENT_GEO, newLoc, 'carousel', true);
				}
				return;
			}

			if (filterKey === 'format') {
				let options = asList(val).map(format => {
					const slug = format.toLowerCase().replace(/\s/g, '');
					return filters.format.options.find(opt => opt.slug === slug) || { slug: slug, label: format };
				});

				const optValues = options.map(e => e.slug).sort();
				const srcValues = (filters.format.current || []).map(e => e.slug).sort();

				// If the new array is the same as the current filter
				if (optValues.length === srcValues.length && !optValues.find((e, i) => srcValues[i] !== e)) {
					options = null; // revert
				}

				Store.emit(actions.TOGGLE_FILTER, 'format', options, true);
				shouldUpdate = true;
			}

			if (filterKey === 'movie' || filterKey === 'movieNot') {
				let options = asList(val).map(m => ({ id: m }));

				const optValues = options.map(e => e.id).sort();
				const srcValues = (filters.movie[filterKey === 'movie' ? 'current' : 'excluded'] || []).map(e => e.id).sort();

				if (optValues.length === srcValues.length && !optValues.find((e, i) => srcValues[i] !== e)) {
					options = null;
				}

				Store.emit(filterKey === 'movie' ? actions.TOGGLE_FILTER : actions.FILTER_EXCLUDE, 'movie', options, true);
				shouldUpdate = true;
			}

			if (filterKey === 'exhibitor') {
				const options = asList(val).map(dom => ({ domain: dom }));

				Store.emit(actions.TOGGLE_FILTER, 'exhibitor', options, true);
				shouldUpdate = true;
			}

			if (filterKey === 'date') {
				let copy = this.props.copy || Store.get().appData.copy || {};
				let options = asList(val).map(dateVal => {
					let date = parseDate(dateVal);
					return new STDate(formatDateTime(date, 'yyyy-MM-dd'), copy);
				});

				const optValues = options.map(e => e.id).sort();
				const srcValues = (filters.stDate.current || []).map(e => e.id).sort();

				if (optValues.length === srcValues.length && !optValues.find((e, i) => srcValues[i] !== e)) {
					options = null;
				}

				Store.emit(actions.TOGGLE_FILTER, 'stDate', options, true);
				shouldUpdate = true;
			}
		});

		if (shouldUpdate) Store.emit(actions.UPDATE_THEATER_FILTERED_SCREENINGS);
	}


	// =~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=
	// Custom render functions

	renderWithoutInActive() {
		const currentItem = this.items[this.state.currentItemIndex];
		const currentSlide = this.sortedItems[this.state.currentItemIndex];
		const duration = currentSlide.slideDuration || this.duration;

		return (
			<Transition
				class={s.transitionWrapper}
				noInitialTransition={true}
				enteringClass={this.enteringClass}
				emptyClass={this.emptyClass}
				visibleClass={this.visibleClass}
				leavingClass={this.leavingClass}
				duration={duration}
			>{/*waitBeforeNext (broken because of direction changing instantly)*/}
				{currentItem}
			</Transition>
		);
	}

	renderWithInactive(navigationArrows) {
		let slides = [];
		slides.push(this.items[this.items.length - 1]);
		slides = slides.concat(this.items);
		slides.push(this.items[0]);

		let slideClass = s.slides;
		const animateToIndex = this.state.currentItemIndex;

		switch (this.state.animateToNewSlide) {
			case 'LEFT':
				slideClass = s.slidesLeft;
				break;
			case 'RIGHT':
				slideClass = s.slidesRight;
				break;
		}

		// ???
		const transformValue = 'translateX(' + ((animateToIndex * - 80) - 70) + '%)';
		const styles = {
			transitionDuration: this.duration + 'ms',
			transform:          transformValue,
			WebkitTransform:    transformValue
		};

		return (
			<div class={s.slidesContainer}>
				{navigationArrows}
				<div class={slideClass} style={styles}>
					{slides}
				</div>
			</div>
		);
	}

	renderWithInactiveCustom(navigationArrows) {
		const currentSlide = this.sortedItems[this.state.currentItemIndex];
		const duration = currentSlide.slideDuration || this.duration;

		let slideClass = '';

		const slideStyle = {
			transitionDuration: duration + 'ms',
			animationDuration: duration + 'ms'
		};

		const functionsData = {
			index:    this.state.currentItemIndex,
			duration: duration
		};

		if (this.props.slideClass) {
			slideClass = typeof this.props.slideClass === 'function' ? this.props.slideClass(functionsData) : this.props.slideClass;
		}

		if (this.props.slideStyle) {
			const newStyle = typeof this.props.slideStyle === 'function' ? this.props.slideStyle(functionsData) : this.props.slideStyle;
			if (newStyle) Object.assign(slideStyle, newStyle);
		}

		return (
			<div class={s.slidesContainer}>
				{navigationArrows}
				<div class={slideClass} style={slideStyle}>
					{this.items}
				</div>
			</div>
		);
	}

	renderThumbnails() {
		return (
			<Playlist
				disableToggle={true}
				list={this.sortedItems}
				activeItem={this.sortedItems[this.state.currentItemIndex]}
				playlistClass={s.playlist}
				onPlaylistItemClick={this.setSlideByItem}
				playlistId={this.props.id}
				device={this.props.device}
			/>
		);
	}

	renderNavigationArrows = () => {
		return [
			<button class={s.leftArrow} onClick={this.prevSlide}><span class={s.arrowIcon} /></button>,
			<button class={s.rightArrow} onClick={this.nextSlide}><span class={s.arrowIcon} /></button>
		];
	}

	renderProgressBar = (activeIndex) => {
		const barWidth = 100 / (this.items.length) * (activeIndex + 1);
		if (this.items.length <= 1) {
			return;
		}
		return (
			<div class={s.progressBar}>
				<div class={s.bar} style={{ width: barWidth + '%' }} />
				<span>{this.props.word || 'Page'} {activeIndex + 1} of {this.items.length}</span>
			</div>
		);
	}

	renderProgressIcons = (activeIndex) => {
		if (this.items.length <= 1) {
			return;
		}
		return (
			<div class={s.progressIcons}>
				{this.items.map((item, index) => {
					const iconClass = index == activeIndex ? s.activeIcon : s.progressIcon;
					return <div class={iconClass} onClick={() => this.setSlide(index)} />;
				})}
			</div>
		);
	}

	renderAnnotation(annotation) {
		const { showReadMore } = this.state;

		const content = annotation.body.charAt(0) === '$' ? getCopy(annotation.body) : annotation.body || '';
		const length = content.split(/[^\s]+/).length - 1;

		const wordBreak = annotation.showMoreWordBreak || 300;
		const contentExpandable = length > wordBreak;
		const smallContent = content.split(/\s+/, wordBreak).join(' ') + (contentExpandable ? ' ...' : '');

		if (annotation.isQuote) {
			const quoteClass  = s.quote ? s.quote : 'carousel_quote';
			const sourceClass = s.quoteSource ? s.quoteSource : 'carousel_quoteSource';
			const bodyClass   = s.quoteBody ? s.quoteBody : 'carousel_quoteBody';
			const rtLogo = annotation.body === "";

			return (
				<blockquote class={joinClasses(s.annotationWrapper, quoteClass, s[annotation.id + 'Quote'])}>
					<HTML class={bodyClass} content={annotation.body} markdown />
					{annotation.image ? (
						<div class={s.imageHolder}>
							<img class={rtLogo? s.rtlogo :s.quoteSourceImage} src={annotation.header.image}/>
							{annotation.header.text && <span class={s.hyphen}>-</span>}
							{annotation.header.text && <p class={s.annotationText}>{annotation.header.text}</p>}
						</div>
					) : (
						<HTML class={sourceClass} content={annotation.header} markdown />
					)}
				</blockquote>
			);
		} else {
			const contentToRender = showReadMore ? content : smallContent;
			return (
				<figcaption class={s.annotationWrapper}>
					<h1>
						{annotation.header && annotation.header.charAt(0) === '$' ? getCopy(annotation.header) : (annotation.header)}
					</h1>
					<HTML content={contentToRender} markdown class={s.annotationBody} />
					{contentExpandable && (
						<Link class={s.readMore} extraOnClick={this.toggleFullBody} renderCustomChild>
							{this.state.showReadMore ? 'Read Less' : 'Read More'}
						</Link>
					)}
				</figcaption>
			);
		}
	}

	renderItem(item, index, mediaRoot, itemClass, hasResponsiveAssets, expandable) {
		// TODO: should we make components for this
		const type = item.type || this.props.type || 'image';

		let src = item.src || item.videoSrc || item.imageSrc || '';
		let posterSrc = item.posterImg;

		const client = Store.get().client;
		const mRoot = mediaRoot ? mediaRoot + '/' : '';

		if (client && hasResponsiveAssets) {
			let filename;
			if (client.deviceSize === 'mobile') filename = item.mobSrc;
			else if (client.deviceSize === 'tablet') filename = item.ipadSrc || item.mobSrc;
			src = filename || src;
		}
		src = src.match(/^(https?:)?\/\//) ? src : mRoot + src;
		if (posterSrc) {
			posterSrc = posterSrc.match(/^(https?:)?\/\//) ? posterSrc : mRoot + posterSrc;
		}

		const imgId = 'carousel_img_' + index;
		const zoom = <Link class={this.state.zoom ? s.zoomedInButton : s.zoomButton} extraOnClick={this.toggleZoom} renderCustomChild></Link>;

		let containerClass = s.itemContainer;
		let itemContent = '';

		if (this.state.currentItemIndex === +index) {
			containerClass = s.activeItemContainer;
		}

		const link = item.link;
		const defaultAutoplay = this.props.autoplay == undefined ? true : this.props.autoplay;
		const autoplay = item.autoplay == undefined ? defaultAutoplay : item.autoplay;
		switch (type) {
			case 'youtube':
				itemContent = (
					<Youtube
						key={item.ytid || item.playlistId}
						activeItem={item}
						maintainAspectRatio
						showInfo
						poster={posterSrc}
						delay={10 * index}
						client={client}
						randomizeId
						autoplay={autoplay}
						fullscreen={false}
						ref={ref => this.$videos[index] = ref}
						onVideoEnded={this.nextSlide}
					/>
				);
				break;

			case 'video':
				const muted = !!this.state.muted || !!item.muted;
				const videoAnnotation = item.annotation ? this.renderAnnotation(item.annotation) : false;
				itemContent = (
					<div class={s.activeVideoContainer}>
						<SimpleVideoPlayer
							enableMobileSoundIOS={item.enableMobileSound}
							overrideHideControls={item.showControls}
							key={item.name}
							loop={item.loop == undefined ? true : item.loop}
							autoplay={autoplay}
							src={src}
							poster={posterSrc}
							muted={muted}
							class={s.activeVideo}
							ref={ref => this.$videos[index] = ref}
							showControls={item.showControls}
							disableGUI
							disableInteraction={item.disableInteraction}
						/>
						{videoAnnotation}
					</div>
				);


				if (this.state.muted) {
					this.$videos[index].setMute(this.state.muted);
				}

				if (link) {
					let linkProps = {};
					if (link.queryString) {
						linkProps.queryString = link.queryString;
					}

					switch (link.type) {
						case 'page' :
							linkProps.pageId = link.url;
							break;
						default :
							linkProps.href = link.url;
							linkProps.target = '_blank';
							break;
					}
					itemContent = (
						<Link trackId={link.trackId} id={imgId} {...linkProps}>
							{itemContent}
						</Link>
					);
				}

				break;

			case 'iframe':
				// ???
				if (item.url) {
					itemContent = <iframe scrolling="no" width='100%' height='100%' src={item.url} {...item.iframeAttrs}></iframe>;
				} else {
					itemContent = <Iframe
						scrolling="no"
						class={joinClasses(s.iframeVideo,item.iframeAttrs && item.iframeAttrs.class)}
						src={`${item.src}`}
						percentageDimensions={true}
					/>;
				}
				break;

			case 'image':
			default:
				const itemAnnotation = item.annotation ? this.renderAnnotation(item.annotation) : false;
				const itemDescription = item.description || "";
				const itemImg = item.src ? (<img src={src} onClick={this.imageItemClick} alt={itemDescription}/>) : false;
				const extraImg = item.extraSrc ? (<img class={s.extraItemImage} src={mRoot + item.extraSrc}/>) : false;
				if (itemAnnotation) {
					itemContent = (
						<div class={this.state.zoom ? joinClasses(s.itemZoom, itemClass) : joinClasses(s.item, itemClass)}>
							{itemImg}
							{extraImg}
							{itemAnnotation}
						</div>
					);
				} else {
					itemContent = <img src={src} alt={itemDescription} onClick={this.imageItemClick} class={this.state.zoom ? s.itemZoom : s.item}/>;
				}

				if (link) {
					let linkProps = {};
					if (link.queryString) {
						linkProps.queryString = link.queryString;
					}

					switch (link.type) {
						case 'filter':
							linkProps.pageId = link.url || 'showtimes';
							linkProps.extraOnClick = this.triggerFilters.bind(this, link);
							break;
						case 'page':
							linkProps.pageId = link.url;
							break;
						case 'download':
							linkProps.href = link.url;
							linkProps.target = '_blank';
							linkProps.download = 'download';
							break;
						default :
							// otherwise assume link is outbound and open in new window
							linkProps.href = link.url;
							linkProps.target = '_blank';
							break;
					}
					itemContent = (
						<Link class={s.item} trackId={link.trackId} id={imgId} {...linkProps}>
							{itemContent}
						</Link>
					);
				}
				break;
		}

		return (
			<figure class={containerClass} id={imgId} ref={ref => ref && (this.$items[index] = ref)}>
				{itemContent}
				{expandable ? zoom : null}
			</figure>
		);
	}

	// Renders the items within the gallery with the appropriate media location
	renderItems = (items, mediaRoot, itemClass, client, hasResponsiveAssets, expandable) => {
		const renderedItems = [];
		let index = 0;

		for (const itemName in items) {
			const item = items[itemName];
			if (item.visible === false) continue; // Skip deactivated items

			const renderedItem = this.renderItem(item, index, mediaRoot, itemClass, hasResponsiveAssets, expandable);
			renderedItems.push(renderedItem);

			index++;
		}
		//debugger
		return renderedItems;
	}


	// =~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=~=~=~~=~=
	// Render

	render(props) {
		const {
			showProgressIcons,
			showProgressBar,
			showNavigationArrows,
			mediaRoot,
			carouselClass,
			itemClass,
			fillContainer,
			client,
			hasResponsiveAssets,
			expandable
		} = props;

		this.items = this.renderItems(this.sortedItems, mediaRoot, itemClass, client, hasResponsiveAssets, expandable);
		let thumbs = showProgressIcons ? this.renderProgressIcons(this.state.currentItemIndex) : '';
		const bar = showProgressBar ? this.renderProgressBar(this.state.currentItemIndex) : '';
		const navigationArrows = showNavigationArrows && this.items.length > 1 ? this.renderNavigationArrows() : '';
		const direction = this.state.currentItemIndex > this.state.previousItemIndex ? 'inc' : 'dec';
		const baseWrapperClass = this.props.renderedItems ? s.slidesWrapper : s.wrapper;
		const fullClass = fillContainer ? s.full : '';
		const wrapperClass = [baseWrapperClass, fullClass, s[direction], carouselClass, s[`${this.props.id}Container`]].filter(e => e).join(' ');

		let slider = '';
		if (this.props.showThumbnails) {
			thumbs = this.renderThumbnails();
		}

		if (this.props.customShowInactive) {
			slider = this.renderWithInactiveCustom(navigationArrows);
		} else if (this.props.showInactive) {
			slider = this.renderWithInactive(navigationArrows);
		} else {
			slider = this.renderWithoutInActive();
		}

		return (
			<div class={wrapperClass}>
				{slider}
				{bar ? bar : thumbs}
				{/* A bit sloppy, but lets display the arrows inside of the slide, so it doesn't get affected by the bullets*/}
				{!this.props.showInactive && navigationArrows}
			</div>
		);
	}

}
